"use client";

import Image from "next/image";
const styles = new Proxy({"UseCases":"UseCases-67f06","usecaseIntro":"usecaseIntro-67f06","Image":"Image-67f06","usecaseCard":"usecaseCard-67f06"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import Section from "../Section";
import RichText from "payload-pms/RichText";
import Link from "next/link";

export type Card = {
  title: string;
  link: string;
  imgSrc: { url: string; width: number; height: number };
  imgAlt: string;
  imgWidth?: number;
  imgHeight?: number;
};

export interface ShiningIconsProps {
  block: {
    title?: string;
    subtitle?: any;
    cards?: Card[];
  };
}

export default function ShiningIcons({ block }: ShiningIconsProps) {
  const { title = "Use Cases", subtitle, cards } = block;

  return (
    <Section className={styles.UseCases} title={title}>
      <div className="row">
        <div className="col-12 py-4">
          <RichText content={subtitle} />
        </div>
      </div>
      <div className={styles.usecaseIntro}>
        <div className="row">
          {cards!.map((card, index) => (
            <div className="col-md-4" key={card.title || index}>
              <Link href={card.link ?? ""}>
                <div className={styles.Image}>
                  <Image
                    src={
                      card.imgSrc?.url
                        ? card.imgSrc.url.length > 0
                          ? card.imgSrc.url
                          : "/"
                        : "/"
                    }
                    alt={card.imgAlt ?? ""}
                    width={card.imgWidth || card.imgSrc?.width || 0}
                    height={card.imgHeight || card.imgSrc?.height || 0}
                    style={{ width: "100%", height: "auto" }}
                  />
                </div>
                <h5 style={{ padding: "0 1em" }}>{card.title}</h5>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}
